import { render, staticRenderFns } from "./CertificateActions.vue?vue&type=template&id=11cc587e"
import script from "./CertificateActions.vue?vue&type=script&lang=js"
export * from "./CertificateActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports